import Stack from "@mui/material/Stack";
import { useMemo } from "react";
import { createListCollection } from "@ark-ui/react";
import { useField, useForm } from "react-final-form";

import { useTranslation } from "@/lib/i18n";
import { BasicWidgetFormProps } from "@/features/widget-forms/dialogs/widget-dialog-types";
import Select from "@/components/select/select";
import {
  MARITIME_BROADCAST_TYPES,
  normalizeMaritimeBroadcastConfiguration,
} from "@/lib/api";

export function MaritimeBroadcastWidgetForm({ values }: BasicWidgetFormProps) {
  const { t } = useTranslation();
  const initialConfiguration = useMemo(
    () => normalizeMaritimeBroadcastConfiguration(values?.configuration),
    [values?.configuration],
  );

  const broadcastTypeCollection = useMemo(
    () =>
      createListCollection({
        items: MARITIME_BROADCAST_TYPES.map((value) => ({
          label: t(`admin.widgets.fields.maritime_broadcast.broadcast_type.${value}`),
          value,
        })),
      }),
    [],
  );

  const form = useForm();
  const broadcastTypeField = useField("configuration.broadcast_type", {
    initialValue: initialConfiguration.broadcast_type,
  });

  return (
    <Stack mt={2}>
      <Select
        label={t("admin.widgets.fields.maritime_broadcast.broadcast_type.label")}
        collection={broadcastTypeCollection}
        name={broadcastTypeField.input.name}
        value={broadcastTypeField.input.value}
        onValueChange={(value) => form.change(broadcastTypeField.input.name, value)}
        error={broadcastTypeField.meta.touched && broadcastTypeField.meta.error}
      />
    </Stack>
  );
}
